module.exports = __webpack_public_path__ + "static/media/bg_like_success.14db2beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/bg_like_success.png
// module id = 2233
// module chunks = 2